module.exports = __webpack_public_path__ + "img/icon_umesr_hover.367dfdac.svg";